/* eslint-disable no-unused-vars */
/* eslint-disable react/prop-types */
import { Separator } from "components/Scorecard/components/scorecardItem/Separator";
import { useNavigate, useParams, useSearchParams } from "react-router-dom";
import React, { useContext, useEffect, useRef, useState } from "react";
import AlertContext from "components/Common/ModalAlert";
import { isUserInTeeTimeUsers } from "utils/teeTime";
import { formatFirestoreTimeStamp } from "utils/";
import { isTeeTimeSubmitted } from "utils/match";
import { Scorecard } from "components/Scorecard";
import { useUserData } from "hooks/useUserData";
import { submitTeeTime } from "services/remote";

import "./styles.css";

import { check2hourGap } from "components/EventTeeTimes";
import Sheet from "react-modal-sheet";
import pinzApiService from "services/pinzApiService";
import MatchPlay from "components/Scorecard/matchPlay";
import { Button } from "components/Common/button";
import Text from "components/Common/Text";
import {
  postHoleValue,
  submitIndividualAsBlock,
  updateTee,
} from "../../services/firebase";
import { useTeeTime } from "../../hooks/useTeeTime";
import { GameHeader } from "../Common/GameHeader";
import { HolesItem } from "./holesItem/holesItem";
import { useEvent } from "../../hooks/useEvent";
import { calculateNetScore } from "../../utils";
import { useAuth } from "../../hooks/useAuth";
import { HolesFooter } from "./holesFooter";
import MatchInfo from "../Common/MatchInfo";
import { Header } from "../Common/Header";
import EditTeesList from "./editTeesList";
import EditTeesListHeader from "./editTeesList/editTeesListHeader";
import ConfirmScoreModal from "./confirmScoreModal";

function Holes() {
  const navigation = useNavigate();

  const { info, clear } = useContext(AlertContext);

  const { user } = useAuth();
  const userData = useUserData(user);
  const { eventId, teeTimeId } = useParams();
  const event = useEvent(eventId);
  const teeTime = useTeeTime(eventId, teeTimeId);

  const { teamsPlay, numberOfTeeTimes } = event ?? {};

  const [searchParams, setSearchParams] = useSearchParams({
    hole: 0,
  });
  const { users, teams } = teeTime ?? [];

  const [isEditTeesModalOpen, setIsEditTeesModalOpen] = useState({
    open: false,
    teesData: null,
    targetUser: null,
    loading: false,
  });

  const [submitScoreModal, setSubmitScoreModal] = useState(false);

  const [isEditTeesButtonShown, setIsEditTeesButtonShown] = useState(false);

  const [submitButtonDisable, setSubmitButtonDisable] = useState(false);

  const sheetRef = useRef();

  useEffect(() => {
    if (navigation) {
      if (event && teeTime) {
        const isJoined = isUserInTeeTimeUsers(userData, teeTime.users, teams);

        if (userData === null || (userData && !isJoined)) {
          // kick out anonymous or not joined users
          navigation(`/event/${event.id}`);
        } else if (isTeeTimeSubmitted(event, teeTime.id)) {
          navigation(`/event/${event.id}/finalScorecard`);
        }
        if (!check2hourGap(teeTime.teeTime)) {
          navigation(`/event/${event.id}`);
        }
      }
    }
  }, [userData, event, teeTime, navigation, teams]);

  const holeIndex = parseInt(searchParams.get("hole"), 10) ?? 0;

  const { uid: currentUserUid } = user;

  const [tab, setTab] = useState("");

  if (!event) {
    return <div>Loading event...</div>;
  }
  if (!teeTime) {
    return <div>Loading tee time...</div>;
  }

  const currentHole = event.holes.at(holeIndex);

  const {
    par: currentPar,
    handicap: currentHoleHandicap,
    holeId,
    createdUtc,
  } = currentHole;

  // eslint-disable-next-line no-unused-vars
  const isScorecardDisabled = users?.length < 2;

  const onScorecardClicked = () => {
    navigation(`/event/${eventId}/${teeTimeId}/scorecard`, {
      replace: true,
      state: { activeHole: holeIndex },
    });
  };

  const inputDefaultHoleJSX = (newHoleIndex) => (
    <div
      style={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "center",
        alignItems: "center",
      }}
    >
      <Text as="H3" style={{ color: "black" }}>
        Please confirm
      </Text>
      <Button
        style={{ marginTop: 24 }}
        title="We made PAR"
        onPress={() =>
          postHoleValue(
            eventId,
            teeTimeId,
            teamsPlay
              ? teams?.find((t) =>
                  t.users.find((u) => u.phone === userData.phone),
                ).users[0]
              : teeTime.users.find((u) => u.phone === userData.phone),
            holeIndex,
            currentHoleHandicap,
            currentPar,
            currentPar,
            holeId,
            event.maxScore,
          )
            .then(clear())
            .then(() =>
              setSearchParams({ hole: newHoleIndex }, { replace: true }),
            )
        }
      />
    </div>
  );

  const saveDefaultValues = (newHoleIndex) => {
    const isScoreUndefined = teamsPlay
      ? teams?.find((t) => t.users?.find((u) => u.phone === userData.phone))
          .users[0].holes[holeIndex].score === undefined
      : users?.find((u) => u.phone === userData.phone).holes[holeIndex]
          .score === undefined;

    if (isScoreUndefined) {
      info(inputDefaultHoleJSX(newHoleIndex));
      return true;
    }

    return false;
  };

  const moveHole = (newHoleIndex) => {
    const res = saveDefaultValues(newHoleIndex);
    if (!res) {
      setSearchParams({ hole: newHoleIndex }, { replace: true });
    }
  };

  const onPrevHole = () => {
    // saveDefaultValues();
    moveHole(holeIndex - 1);
  };

  const onNextHole = () => {
    const eventHolesLength = event.holes?.length;

    if (holeIndex < eventHolesLength - 1) {
      moveHole(holeIndex + 1);
    } else if (holeIndex === eventHolesLength - 1) {
      saveDefaultValues(17);
      // onScorecardClicked();
      // navigation(
      //   `/event/${eventId}/${teeTimeId}/holes?hole=17&scorecard=true`,
      //   {
      //     replace: false,
      //     state: { activeHole: holeIndex },
      //   },
      // );
    }
  };

  const changeHoleValue = (teeTimeUser, value) => {
    postHoleValue(
      eventId,
      teeTimeId,
      teeTimeUser,
      holeIndex,
      currentHoleHandicap,
      currentPar,
      value,
      holeId,
      event.maxScore,
    );
  };

  const increaseValue = async (teeTimeUser) => {
    const value = teeTimeUser.holes?.at(holeIndex).score ?? currentPar;
    changeHoleValue(teeTimeUser, value + 1);
  };

  const minHoleScore = 1;
  const decreaseValue = async (teeTimeUser) => {
    const score = teeTimeUser.holes?.at(holeIndex).score;
    const newScore = Math.max(minHoleScore, (score ?? currentPar) - 1);
    if (score !== newScore) {
      changeHoleValue(teeTimeUser, newScore);
    }
  };

  const teeTimeTime = formatFirestoreTimeStamp(teeTime.teeTime, "hh:mma");

  const addTeamNameToEveryUserObject =
    teeTime?.teams?.map((tm) => {
      // eslint-disable-next-line no-param-reassign
      tm.users = tm.users.map((us) => ({ ...us, teamName: tm.name }));
      return tm;
    }) ?? [];

  const usersList = teamsPlay
    ? addTeamNameToEveryUserObject?.reduce(
        (acc, team) => [...acc, ...team.users],
        [],
      )
    : teeTime?.users ?? {};

  function checkProperties(array) {
    const { usersList: checkUsersArray } = array ?? [];
    const allPropertiesPresent = checkUsersArray?.every((obj) =>
      obj.holes?.every(
        (hole) =>
          hole &&
          Object.prototype.hasOwnProperty.call(hole, "score") &&
          Object.prototype.hasOwnProperty.call(hole, "netScore") &&
          Object.prototype.hasOwnProperty.call(hole, "grossToPar") &&
          Object.prototype.hasOwnProperty.call(hole, "quota"),
      ),
    );

    if (allPropertiesPresent) {
      return true; // All required properties are present
    }
    return false; // One or more required properties are missing
  }

  function checkIndividual(activeUser) {
    const allPropertiesPresent = activeUser.holes?.every(
      (hole) =>
        hole &&
        Object.prototype.hasOwnProperty.call(hole, "score") &&
        Object.prototype.hasOwnProperty.call(hole, "netScore") &&
        Object.prototype.hasOwnProperty.call(hole, "grossToPar") &&
        Object.prototype.hasOwnProperty.call(hole, "quota"),
    );

    if (allPropertiesPresent) {
      return true; // All required properties are present
    }
    return false; // One or more required properties are missing
  }

  const onSubmitMatchDisabled =
    !submitButtonDisable &&
    usersList?.length &&
    checkIndividual(users?.find((u) => u.phone === userData.phone));

  const submitMatch = async () => {
    setSubmitButtonDisable(!submitButtonDisable);
    try {
      await submitTeeTime(eventId, teeTimeId, event.teamsPlay);
    } catch (err) {
      setSubmitButtonDisable(false);
    }
  };

  // eslint-disable-next-line consistent-return
  const onSubmitMatch = async () => {
    if (checkIndividual(users?.find((u) => u.phone === userData.phone))) {
      if (!checkProperties({ usersList })) {
        info(
          <>
            <Text as="H2" style={{ color: "black" }}>
              Are you sure?
            </Text>
            <Button
              style={{ width: "100%", marginTop: 24 }}
              title="Yes, submit score"
              onPress={() =>
                submitIndividualAsBlock(
                  eventId,
                  teeTimeId,
                  userData.phone,
                ).then(clear())
              }
            />
          </>,
        );
      } else {
        submitMatch();
      }
    }
  };

  const onOpenEditModal = async (usr) => {
    const { courseId } = event ?? {};

    setIsEditTeesModalOpen(() => ({
      loading: true,
      open: true,
    }));

    try {
      const res = await pinzApiService.getTeesByCourseId({
        courseId,
        gender: userData.gender || "M",
      });

      if (res) {
        setIsEditTeesModalOpen(() => ({
          teesData: res.tees,
          open: true,
          targetUser: usr,
          loading: false,
        }));
      }
    } catch (err) {
      info(err);
    }
  };

  const updateTeeForUser = async (tee) => {
    const uD = {
      handicap: isEditTeesModalOpen.targetUser.handicapIndex,
      phone: isEditTeesModalOpen.targetUser.phone,
      uid: isEditTeesModalOpen.targetUser.uid,
    };
    try {
      updateTee(eventId, teeTimeId, uD, tee);
      setIsEditTeesModalOpen(() => ({ open: false }));
    } catch (e) {
      info(e);
    }
  };

  const usersComponent = (array) =>
    array
      ?.filter((u) => currentUserUid === u.uid)
      .map((i, index) => {
        const score = i.holes?.at(holeIndex).score;
        const netScore = i.holes?.at(holeIndex).netScore;
        const userValue = score === netScore ? score ?? null : score;

        const userNetScore =
          i.holes?.at(holeIndex).netScore ??
          calculateNetScore(i.courseHandicap, currentHoleHandicap, userValue);

        const { teeName } = i ?? {};

        const netDepsMatchType = {
          0: false,
          1: true,
          2: false,
          3: false,
          4: false,
          5: true,
          6: false,
          7: true,
          8: true,
        };

        const netDepsMatchTypeKicker = {
          0: false,
          1: true,
          2: false,
          3: false,
          4: false,
          5: true,
          6: false,
          7: true,
          8: true,
        };

        return (
          <React.Fragment key={i.uid}>
            <HolesItem
              currentPar={currentPar}
              currentHoleIndex={holeIndex}
              isCurrentUser={currentUserUid === i.uid}
              displayName={i.displayName}
              handicap={i.courseHandicap}
              userValue={userValue}
              userNetScore={userNetScore}
              onIncreaseValue={() => increaseValue(i)}
              onDecreaseValue={() => decreaseValue(i)}
              ntp={index % 2 === 1}
              editTeesButtonShown={isEditTeesButtonShown}
              onEditTees={() => onOpenEditModal(i)}
              teeName={teeName}
              matchType={event.matchType}
              matchTypeNet={netDepsMatchType[event.matchType]}
              kickerTypeNet={
                event.bets.length > 0
                  ? netDepsMatchTypeKicker[event.bets[0].matchType]
                  : false
              }
              disableInput={
                users?.find((u) => u.phone === userData.phone).blockHoles ||
                false
              }
            />

            <Separator showTime teeTimeString="Scorecard" />
            <Scorecard
              teamsPlay={teamsPlay}
              currentHoleIndex={holeIndex}
              hideLegend
            />

            <HolesFooter
              onPrevHole={onPrevHole}
              holeIndex={holeIndex}
              onNextHole={onNextHole}
              onSubmitMatchDisabled={onSubmitMatchDisabled}
              onSubmitMatch={onSubmitMatch}
              isBlockedSubmit={
                users?.find((u) => u.phone === userData.phone).blockHoles ||
                false
              }
            />
          </React.Fragment>
        );
      });

  const renderHolesItem = () => {
    if (teamsPlay) {
      return teams?.map((team) => (
        <div key={team.teamId}>
          <Separator showTime={false} teeTimeString={team.name} />
          <div>{usersComponent(team.users)}</div>
        </div>
      ));
    }
    return usersComponent(users);
  };

  const renderTab = (tabName) => {
    switch (tabName) {
      case "Scoring":
        return (
          <>
            <GameHeader
              holeNumber={holeIndex}
              holePar={currentPar}
              hdcp={currentHoleHandicap}
              createdUtc={createdUtc}
              onEditTees={() =>
                setIsEditTeesButtonShown(!isEditTeesButtonShown)
              }
              onEditTeesOpen={isEditTeesButtonShown}
            />
            <div className="holes-list--wrapper">
              {event?.teamPlay && (
                <div className="holes-list--header">
                  <div className="holes-list--header-time">
                    {teeTimeTime} Playing
                  </div>
                </div>
              )}
              <div className="holes-list-container">{renderHolesItem()}</div>
            </div>
          </>
        );

      case "Scorecard":
        return (
          <div>
            <Scorecard teamsPlay={teamsPlay} />
            <HolesFooter
              onPrevHole={() => {
                moveHole(17);
              }}
              onNextHole={() => moveHole(0)}
              onScorecardClicked={onScorecardClicked}
              onSubmitMatchDisabled={onSubmitMatchDisabled}
              onSubmitMatch={onSubmitMatch}
              isBlockedSubmit={
                users?.find((u) => u.phone === userData.phone).blockHoles ||
                false
              }
            />
          </div>
        );
      case "Quota":
        return (
          <div>
            <Scorecard quota teamsPlay={teamsPlay} />
            <HolesFooter
              onPrevHole={() => {
                moveHole(17);
              }}
              onNextHole={() =>
                navigation(
                  `/event/${eventId}/${teeTimeId}/holes?scorecard=true`,
                  {
                    replace: true,
                  },
                )
              }
              onScorecardClicked={onScorecardClicked}
              onSubmitMatchDisabled={onSubmitMatchDisabled}
              onSubmitMatch={onSubmitMatch}
              isBlockedSubmit={
                users?.find((u) => u.phone === userData.phone).blockHoles ||
                false
              }
            />
          </div>
        );

      case "Match":
        return (
          userData && (
            <div>
              <MatchPlay
                data={usersList}
                teams={teams}
                teamsPlay={teamsPlay}
                numberOfTeeTimes={numberOfTeeTimes}
              />
            </div>
          )
        );
      default:
        return <div>Error</div>;
    }
  };

  return (
    <div
      style={{
        flexDirection: "column",
        display: "flex",
        justifyContent: "space-between",
        width: "100%",
        height: "100%",
      }}
    >
      <div>
        <Header event={event} userData={userData} hideQr goBack />
        <MatchInfo event={event} activeTab={(i) => setTab(i)} />

        {renderTab(tab)}
        <Sheet
          isOpen={isEditTeesModalOpen.open || submitScoreModal}
          onClose={() =>
            submitScoreModal
              ? setSubmitScoreModal(false)
              : setIsEditTeesModalOpen((prevState) => ({
                  ...prevState,
                  open: false,
                }))
          }
          detent="content-height"
          ref={sheetRef}
        >
          <Sheet.Container
            style={{
              backgroundColor: "#EDEFEF",
              borderTopLeftRadius: 16,
              borderTopRightRadius: 16,
            }}
          >
            <Sheet.Header>
              <EditTeesListHeader
                courseName={
                  submitScoreModal ? "Confirm Scores" : event?.courseName
                }
                onClose={() =>
                  submitScoreModal
                    ? setSubmitScoreModal(false)
                    : setIsEditTeesModalOpen((prevState) => ({
                        ...prevState,
                        open: false,
                      }))
                }
              />
            </Sheet.Header>
            <Sheet.Content style={{ paddingBottom: sheetRef.current?.y }}>
              {submitScoreModal ? (
                <ConfirmScoreModal
                  courseName={event?.courseName}
                  users={
                    teamsPlay ? teams?.map((tm) => tm.users)?.flat() : users
                  }
                  date={teeTime?.teeTime}
                  onSubmit={() => submitMatch()}
                  submitButtonDisable={submitButtonDisable}
                />
              ) : (
                <EditTeesList
                  isLoading={isEditTeesModalOpen.loading}
                  teesData={isEditTeesModalOpen.teesData}
                  onSelectTee={(teeData) => updateTeeForUser(teeData)}
                  activeTeeId={isEditTeesModalOpen?.targetUser?.teeId || ""}
                />
              )}
            </Sheet.Content>
          </Sheet.Container>

          <Sheet.Backdrop />
        </Sheet>
      </div>
    </div>
  );
}

export { Holes };
